import { Component, Input } from "@angular/core";
import {
  CustomColumnComponent,
  DataService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { Observable, map } from "rxjs";
import { GetCustomerCooperateDocument } from "src/generated-gql/graphql";

@Component({
  selector: "is-cooperate-column",
  imports: [SharedModule],
  templateUrl: "./is-cooperate-column.component.html",
  standalone: true,
})
export class IsCooperateColumnComponent implements CustomColumnComponent {
  @Input() rowItem: {
    id: string;
  };

  isCooperate$: Observable<boolean>;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    //console.log(this.rowItem);
    this.isCooperate$ = this.dataService
      .query(GetCustomerCooperateDocument, {
        id: this.rowItem.id,
      })
      .mapSingle((res) => {
        if (res.customer?.customFields?.cooperateUser) {
          return true;
        }

        return false;
      });
  }
}
